<template>
  <DetailTemplate tuijian product></DetailTemplate>
</template>

<script>
import DetailTemplate from "~/components/template/DetailTemplate.vue";
export default {
  components: {DetailTemplate}
}
</script>



// WEBPACK FOOTER //
// src/views/service/productionInfo.vue